import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCubes,
  faExclamation,
  faFileExport,
  faInfoCircle,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
declare var $: any;
import { PlannerComponent } from '../planner/planner.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { LandscaperComponent } from '../landscaper/landscaper.component';
import { ReloadToolService } from '../shared/services/reload-tool.service';

@Component({
  selector: 'app-scope-mapper',
  templateUrl: './scope-mapper.component.html',
  styleUrls: ['./scope-mapper.component.scss'],
})
export class ScopeMapperComponent implements OnInit {
  /// icons
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faCubes = faCubes;
  faCircle = faCircle;
  faCheck = faCheck;
  faExclamation = faExclamation;

  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private appService: AppService,
    public mainComponent: MainComponent,
    private reloadToolService: ReloadToolService,
    public plannerComponent: PlannerComponent,
    public LandscaperComponent: LandscaperComponent,
    public interactionMapperComponent: InteractionMapperComponent,
    private pagerService: PagerService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

  }
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  mapAciveAxisType: any;
  modelData: any;
  disableDown: any;
  disableUp: any;

  /// app file open
  eutCollection: any = { TF: [], UR: [], BF: [], XX: []  };
  scopeMap: any;
  listOfEUTs: any;
  listOfAttributes: any;
  // model: any;

  /// app file close

  /// model file open
  model: any = {
    planner: {},
    startAt: 0,
    eutType: 'TF',
    maxColumns: 15,
    maxRows: 12,
    listLength: 10,
    xTabValid: true,
    eutCollection: {},
    deSelectCollection: this.Config.UIstates.scopeMapper,
    attributes: this.Config.listOfAttributes,
    sMap: {},
    scopeMap: {},
    scopeMapUI: {},
    scopeMapIndex: {},
  };

  /// model file close

  /// controller file open
  selectedHeaderName: any;
  selectedScope: any;
  scopeEntityTF: any = ' (0)';
  scopeEntityUR: any = ' (0)';
  scopeEntityBF: any = ' (0)';
  scopeEntityXX: any = ' (0)';
  totalScopeEntityCount: any = 0;
  scopeGraphStatus: any;
  EUTtypes: any;
  selectedEUT: any;
  scopeSwitchStatus: any;
  activeTabID: any;
  matchedAttribute: any;
  matchedEntity: any;
  /// controller file close

  ngOnInit(): void {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    setTimeout(() => {
      this.getVideoURL('Sc')
    }, 2000);
    this.changeAxisTab('yAxis');
    this.modelData = this._sharedService.loadedProjectData.model;
    this.scopeMap = this.modelData.scopeMap;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.listOfAttributes = this.modelData.listOfAttributes;
    this.eutCollection['TF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.eutCollection['UR'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.eutCollection['BF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );
    this.eutCollection['XX'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'XX'
    );

    this.allItems = this.eutCollection['TF'];
    this.setPage(1);

    /// ctrl

    this.scopeGraphStatus = false;
    this.EUTtypes = ['TF', 'UR', 'BF', 'XX'];
    this.selectedScope = { name: 'Migration', symbol: 'Mi' };
    this.selectedEUT = { eID: 'TF1' };
    this.scopeSwitchStatus = false;
    this.activeTabID = 'yAxisFeatureTableSM';

    /// model
    this.model.eutCollection = this.eutCollection;
    this.model.sMap = this.modelData.scopeMap;
    this.model.scopeMap = {
      TF: [],
      UR: [],
      BF: [],
      XX: [],
    };
    this.model.scopeMapUI = {
      TF: [],
      UR: [],
      BF: [],
      XX: [],
    };
    this.model.scopeMapIndex = {
      TF: [],
      UR: [],
      BF: [],
      XX: [],
    };
    this.loadScopeMap(this.model.sMap, this.model.eutCollection);
    this.loadScopeMapUI(this.model.eutCollection);
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
  }


  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  /// controller fn open

  getAttributeDesc(Attribute: any) {
    var concatAttr = Attribute.name.name + ' (' + Attribute.name.symbol + ')';
    this.matchedAttribute = this.listOfAttributes.find(
      (att: any) => att.aType == concatAttr
    );
    if (this.matchedAttribute) {
      return this.matchedAttribute.aDetail;
      // if (this.matchedAttribute.aDetail == '') {
      //   return "attributeNoFont";
      // } else {
      //   return "attributeFont";
      // }
    }
  }

  checkAttributeDesc(Attribute: any, checkFor: any) {
    var concatAttr = Attribute.name.name + ' (' + Attribute.name.symbol + ')';
    this.matchedAttribute = this.listOfAttributes.find(
      (att: any) => att.aType == concatAttr
    );
    if (this.matchedAttribute) {
      if (this.matchedAttribute.aDetail == '') {
        // if (checkFor == 'text') {
        // return 'attributeNoFont';
        // } else {
        return true;
        // }
      } else {
        // if (checkFor == 'text') {
        // return 'attributeFont';
        // } else {
        return false;
        // }
      }
    } else {
      return true;
    }
  }

  checkAttributeMapped(Attribute: any, checkFor: any) {
    if (this.checkAttributeDesc(Attribute, 'icon') == false) {
      return true;
    } else {
      this.matchedEntity = Attribute.eutList.find((eut: any) => eut.map == '*');
      if (this.matchedEntity) {
        return false;
      }
      return true;
    }
  }

  scopeMapSwitch(switchStatus: any) {
    this.resetActiveTabBySwitchView(!switchStatus);
    if (switchStatus == true) {
      $('.xAttSelectPersona').hide();
      $('.yAttSelectEut').show();
      $('.yAttSelectPersona').hide();
      $('.xAttSelectEut').hide();
      $('.xAttSelectAttribute').show();
      $('.yAttSelectAttribute').hide();
      this.selectedScopeMap(this.Config.listOfAttributes[0]);
      this.scopeSwitchStatus = false;
      $('input[name="attributes"]').first().prop('checked', true);
    } else {
      $('.xAttSelectPersona').hide();
      $('.yAttSelectEut').hide();
      $('.yAttSelectPersona').hide();
      $('.xAttSelectEut').show();
      $('.xAttSelectAttribute').hide();
      $('.yAttSelectAttribute').show();
      this.selectedEutMap(this.listOfEUTs[0]);
      this.scopeSwitchStatus = true;
    }
  }

  //load the persona map according to the shifted tab
  //set the eut type and reset the value of start
  setEUTtypeChosen(eutChosen: any) {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.model.eutType = eutChosen;
    this.model.startAt = 0;

    this.allItems = this.eutCollection[eutChosen];
    this.setPage(1);

    this.loadScopeMap(this.model.sMap, this.eutCollection);
    this.loadScopeMapUI(this.eutCollection);
    this.isUpDownValid();
  }

  resetActiveTab(status: any) {
    // console.log('resetActiveTab called in SM', status);
    if (status == false) {
      $('#yAxisFeatureTableSM').removeClass('active');
      $('#yAxisRequirementTableSM').removeClass('active');
      $('#yAxisFlowTableSM').removeClass('active');
      $('#yAxisUnspecTableSM').removeClass('active');
      $('#yAxisActiveTabSM').removeClass('active');
      $('#yAxisFeatureSM').removeClass('active');
      $('#yAxisRequirementSM').removeClass('active');
      $('#yAxisFlowSM').removeClass('active');
      $('#xAxisActiveTabSM').removeClass('active');
      $('#xAxisFeatureSM').removeClass('active');
      $('#xAxisRequirementSM').removeClass('active');
      $('#xAxisFlowSM').removeClass('active');
      $('#yAxisActiveTabSM').addClass('active');
      // $("#yAxisFeatureSM").addClass('active');
      this.activeTabID = 'yAxisActiveTabSM';
      // console.log('this.activeTabID1', this.activeTabID);
    } else {
      $('#yAxisFeatureTableSM').removeClass('active');
      $('#yAxisRequirementTableSM').removeClass('active');
      $('#yAxisFlowTableSM').removeClass('active');
      $('#yAxisUnspecTableSM').removeClass('active');
      $('#yAxisActiveTabSM').removeClass('active');
      $('#yAxisFeatureSM').removeClass('active');
      $('#yAxisRequirementSM').removeClass('active');
      $('#yAxisFlowSM').removeClass('active');
      $('#xAxisActiveTabSM').removeClass('active');
      $('#xAxisFeatureSM').removeClass('active');
      $('#xAxisRequirementSM').removeClass('active');
      $('#xAxisFlowSM').removeClass('active');
      $('#yAxisFeatureTableSM').addClass('active');
      this.setEUTtypeChosen('TF');
      this.activeTabID = 'yAxisFeatureTableSM';
      // console.log('this.activeTabID2', this.activeTabID);
    }
  }

  resetActiveTabBySwitchView(status: any) {
    // console.log('resetActiveTabBySwitchView calledin SM', status);
    if (status == false) {
      $('#yAxisFeatureTableSM').removeClass('active');
      $('#yAxisRequirementTableSM').removeClass('active');
      $('#yAxisFlowTableSM').removeClass('active');
      $('#yAxisUnspecTableSM').removeClass('active');
      $('#yAxisActiveTabSM').removeClass('active');
      $('#yAxisFeatureSM').removeClass('active');
      $('#yAxisRequirementSM').removeClass('active');
      $('#yAxisFlowSM').removeClass('active');
      $('#xAxisActiveTabSM').removeClass('active');
      $('#xAxisFeatureSM').removeClass('active');
      $('#xAxisRequirementSM').removeClass('active');
      $('#xAxisFlowSM').removeClass('active');
      $('#yAxisActiveTabSM').addClass('active');
      // this.setMappingSelectedyEut('Feature');
      this.activeTabID = 'yAxisActiveTabSM';
      // console.log('this.activeTabID3', this.activeTabID);
    } else {
      $('#yAxisFeatureTableSM').removeClass('active');
      $('#yAxisRequirementTableSM').removeClass('active');
      $('#yAxisFlowTableSM').removeClass('active');
      $('#yAxisUnspecTableSM').removeClass('active');
      $('#yAxisActiveTabSM').removeClass('active');
      $('#yAxisFeatureSM').removeClass('active');
      $('#yAxisRequirementSM').removeClass('active');
      $('#yAxisFlowSM').removeClass('active');
      $('#xAxisActiveTabSM').removeClass('active');
      $('#xAxisFeatureSM').removeClass('active');
      $('#xAxisRequirementSM').removeClass('active');
      $('#xAxisFlowSM').removeClass('active');
      $('#yAxisActiveTabSM').addClass('active');
      this.activeTabID = 'yAxisActiveTabSM';
      // console.log('this.activeTabID4', this.activeTabID);
    }
  }

  scopeGraphShowHide(graphStatus: any) {
    this.resetActiveTab(graphStatus);
    if (graphStatus == false) {
      $('.scopeTableView').hide();
      $('.scopeGraph').show();
      this.scopeGraphStatus = true;
      this.scopeMapSwitch(true);
    } else {
      $('.scopeTableView').show();
      $('.scopeGraph').hide();
      this.scopeGraphStatus = false;
    }
    // this.getMappingInteractionSelected(this.listOfEUTs[0]);
  }

  //when select all is checked
  //empty my ids from delselected id list
  // and change the value of check in the eid list also
  toggleAllDeselect(checkVal: any) {
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        this.model.deSelectCollection[this.model.eutType].splice(eID, 1);
      } else {
        var isPresent = this.model.deSelectCollection[
          this.model.eutType
        ].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        if (isPresent == -1) {
          this.model.deSelectCollection[this.model.eutType].push(
            this.eutCollection[this.model.eutType][i].eID
          );
        }
      }
    }
    this.loadScopeMap(this.model.sMap, this.eutCollection);
    this.loadScopeMapUI(this.eutCollection);
  }

  toggleSelection(eID: any) {
    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == eID
    );
    // Is currently selected
    if (isPresent > -1) {
      this.model.deSelectCollection[this.model.eutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.deSelectCollection[this.model.eutType].push(eID);
    }
    this.loadScopeMap(this.model.sMap, this.eutCollection);
    this.loadScopeMapUI(this.eutCollection);
  }

  nextPage() {
    //finding start of list
    var startPosition = this.model.startAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if (this.eutCollection[this.model.eutType].length > startPosition) {
      this.model.startAt = startPosition;
      this.loadScopeMap(this.model.sMap, this.eutCollection);
      this.loadScopeMapUI(this.eutCollection);
    }
    this.isUpDownValid();
  }

  previousPage() {
    var startPosition = this.model.startAt - this.model.listLength;

    if (startPosition >= 0) {
      this.model.startAt = startPosition;
      this.loadScopeMap(this.model.sMap, this.eutCollection);
      this.loadScopeMapUI(this.eutCollection);
    }
    this.isUpDownValid();
  }

  firstPage() {
    this.model.startAt = 0;
    this.loadScopeMap(this.model.sMap, this.eutCollection);
    this.loadScopeMapUI(this.eutCollection);
    this.isUpDownValid();
  }

  lastPage() {
    this.model.startAt =
      this.eutCollection[this.model.eutType].length -
      (this.eutCollection[this.model.eutType].length % this.model.listLength);
    this.loadScopeMap(this.model.sMap, this.eutCollection);
    this.loadScopeMapUI(this.eutCollection);
    this.isUpDownValid();
  }

  isUpDownValid() {
    this.disableDown =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? true
        : false;
    this.disableUp = this.model.startAt - 1 >= 0 ? true : false;
  }

  isChecked(ID: any) {
    var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == ID
    );
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }

  isAllSelected() {
    var count = 0;
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      var isPresent = this.model.deSelectCollection[
        this.model.eutType
      ].findIndex(
        (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
      );
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.startAt;
    if (count == 0) {
      return true;
    } else if (count == noOfRows || count < noOfRows) {
      return false;
    } else {
      return false; /// added to avoid error
    }
  }

  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  entityExistsCheck(eType: any) {
    var entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  checkEntityScopeMap(eut: any, selected: any) {
    for (var i = 0; i < this.scopeMap.length; i++) {
      if (
        this.scopeMap[i].eID == eut.eID &&
        this.scopeMap[i].aType == selected.symbol
      ) {
        return true;
      }
    }
    return false;
  }
  selectedScopeMap(scope: any) {
    this.scopeEntityTF = ' (0)';
    this.scopeEntityUR = ' (0)';
    this.scopeEntityBF = ' (0)';
    this.scopeEntityXX = ' (0)';
    this.totalScopeEntityCount = 0;
    this.selectedScope = scope;
    this.selectedHeaderName = this.selectedScope.name;
  }

  selectedEutMap(eut: any) {
    // console.log('scope eut', eut);
    this.selectedEUT = eut;
    this.selectedHeaderName = this.selectedEUT.eName;
  }

  generateReport(auto: any) {
    let mapperArray = ['ScopeMapper'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF', 'XX']));
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  activeTab(tabID: any) {
    this.activeTabID = tabID;
    // console.log('activeTab this.activeTabID', this.activeTabID);
  }
  /// controller fn close

  /// model fn open

  //Construct the persona map for each eut type and load the map collection
  //after constructing check the persona map and mark * if there is a mapping for the person with eut
  loadScopeMap(sMap: any, eutCollection: any) {
    var model = this;
    for (var key in eutCollection) {
      model.scopeMap[key] = [];
      this.model.attributes.forEach((attribute: any) => {
        var eutList: any = [];
        eutCollection[key].forEach(function (eut: any) {
          var mapped = sMap.find(function (amap: any) {
            return attribute.symbol == amap.aType && eut.eID == amap.eID;
          });
          if (mapped) {
            eutList.push({
              eID: eut.eID,
              map: '*',
            });
          } else if (!mapped) {
            eutList.push({
              eID: eut.eID,
              map: '',
            });
          }
        });
        model.scopeMap[key].push({
          name: attribute,
          eutList,
        });
      });
    }
  }

  loadScopeMapUI(eutCollection: any) {
    for (var key in eutCollection) {
      //cloning the persona map to persona map ui
      this.model.scopeMapUI[key] = $.extend(true, [], this.scopeMap[key]);

      //for every persona
      //start from the list index in personamapUI
      //check whether eid in eut is in the deselected list and splice it
      //loop till max columns
      this.model.scopeMapUI[key].forEach((attribute: any) => {
        for (
          i = attribute.eutList.length - 1;
          i >= this.model.startAt;
          i -= 1
        ) {
          var idExist = this.model.deSelectCollection[key].find(
            (id: any) => id == attribute.eutList[i].eID
          );
          if (idExist) {
            attribute.eutList.splice(i, 1);
          }
        }

        attribute.eutList.splice(0, this.model.startAt);
        if (attribute.eutList.length > this.model.maxColumns) {
          attribute.eutList.splice(
            this.model.maxColumns,
            attribute.eutList.length - this.model.maxColumns
          );
        }

        for (var i = attribute.eutList.length; i < this.model.maxColumns; i++) {
          attribute.eutList.push({
            map: '-1',
          });
        }
      });

      //adding rows and columns to match the max rows and columns
      for (
        var i = this.model.scopeMapUI[key].length;
        i < this.model.maxRows;
        i++
      ) {
        var eutList = [];
        for (var j = 0; j < this.model.maxColumns; j++) {
          eutList.push({
            map: '-1',
          });
        }
        this.model.scopeMapUI[key].push({
          name: '',
          eutList,
        });
      }
      //for the last row of index
      //check if eid exist in deselected list
      //if exist then skip it
      var eutList = [];

      for (var i = this.model.startAt; i < eutCollection[key].length; i++) {
        var idExist = this.model.deSelectCollection[key].find(
          (id: any) => id == eutCollection[key][i].eID
        );
        if (!idExist && eutList.length < this.model.maxColumns) {
          eutList.push({
            map: i + 1,
          });
        } else if (idExist) {
          eutCollection[key][i].checked = false;
        }
      }
      for (var j = eutList.length; j < this.model.maxColumns; j++) {
        eutList.push({
          map: '-1',
        });
      }
      this.model.scopeMapIndex[key].push({
        name: '',
        eutList,
      });
    }
  }

  // Handler to update the UI PeonalMap model & teh actual PersonaMap model
  update(sChosen: any, eutIDChosen: any, eutID: any) {
    // Update the UI Persona Map Model
    sChosen.eutList[eutIDChosen].map =
      sChosen.eutList[eutIDChosen].map == '*' ? '' : '*';

    // Npw update the "actual" Persona Map model
    var mappingExist = this.model.sMap.find(
      (map: any) => map.aType == sChosen.name.symbol && map.eID == eutID
    );
    if (mappingExist) {
      this.delete(sChosen.name.symbol, eutID);
    } else {
      this.add(sChosen.name.symbol, eutID);
    }
  }

  getScopeForAnEut(eutID: any) {
    var mappedScopeForEut = this.model.sMap.filter(
      (map: any) => map.eID == eutID
    );
    return mappedScopeForEut;
  }

  mapScopeEntity(checked: any, att: any, eutID: any) {
    if (checked.target.checked == true) {
      this.add(att, eutID);
    } else {
      this.delete(att, eutID);
    }
  }

  add(att: any, eutID: any) {
    this.model.sMap.push({
      aType: att,
      eID: eutID,
    });
    var eut = this.listOfEUTs.find((eut: any) => eut.eID == eutID);
    var attribute = this.model.attributes.find(
      (attr: any) => attr.symbol == att
    );
    if (eut) {
      var Task = this.modelData.tasks.find((eut: any) => eut.entity_Id == eutID);
      this.generateTaskFromScope(Task, attribute);
      for(var i = 0; i < this.modelData.tasks.length; i ++){
        if(this.modelData.tasks[i].entity_Id == eutID){
          if(this.modelData.tasks[i].toolType == 'pm' || this.modelData.tasks[i].toolType == 'im' || this.modelData.tasks[i].toolType == 'sc' || this.modelData.tasks[i].toolType == 'dd'){
            this.modelData.tasks[i]['attribute'] = attribute;
          }
        }
      }
    }
  }

  delete(att: any, eutID: any) {
    var index = this.model.sMap.findIndex(
      (map: any) => map.eID == eutID && map.aType == att
    );
    if (index > -1) {
      this.model.sMap.splice(index, 1);
    }
    var eut = this.listOfEUTs.find((eut: any) => eut.eID == eutID);

    if (eut) {
      // var Task = this.modelData.tasks.find((eut: any) => eut.entity_Id == eID);
      // this.generateTaskFromScope(Task, attribute);
      for(var i = 0; i < this.modelData.tasks.length; i ++){
        if(this.modelData.tasks[i].entity_Id == eutID && this.modelData.tasks[i].attribute.symbol == att && (this.modelData.tasks[i].toolType == 'de' || this.modelData.tasks[i].toolType == 'ex')){
          this.modelData.tasks.splice(i, 1);
          i--;
        }
      }
    }
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
  }

  generateTaskFromScope(task: any, attribute: any) {
    // console.log("task", task);
    // console.log("attribute", attribute);
    let taskCreateArray = ['de', 'ex'];
    for (var i = 0; i < taskCreateArray.length; i++) {
      this.generateTaskObjScope(task, attribute, taskCreateArray[i]);
    }
  }

  generateTaskObjScope(task: any, attribute: any, toolType: any) {
    let taskObj: any = {};
    taskObj.task_combine_id = task.task_combine_id;
    taskObj.assignedto = task.assignedto;
    taskObj.assigneduser = task.assigneduser;
    taskObj.attribute = attribute;
    // taskObj.environment = this.model.choosenEntity.environment;
    taskObj.task_desc = this.LandscaperComponent.generateTaskDesc(toolType, task.entity_desc, attribute.name);
    taskObj.activity = { type: 'TN', name: 'Test', shortfrom: 'Test' };
    taskObj.toolType = toolType;
    taskObj.moduleName = task.moduleName;
    taskObj.moduleID = task.moduleID;
    taskObj.entity_Id = task.entity_Id;
    taskObj.entity_desc = task.entity_desc;
    taskObj.entityType = task.entityType;
    // taskObj.primaryentity_Id = this.model.choosenEntity.entity_Id;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    // console.log("this.modelData.tasks", this.modelData.tasks);
  }
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  /// model fn close

  getVideoURL(urlName: any) {
    // console.log("urlName",urlName);
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    // console.log("videoURL",videoURL);
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }
  //function to get modulename by moduleID
  getModuleName(eut: any){
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  
  changeAxisTab(type: any) {
    this.mapAciveAxisType = type;
  }
}
